<label class="inline-flex items-center gap-2 cursor-pointer select-none">
  <input
    type="checkbox"
    class="sr-only peer"
    [checked]="checked()"
    [disabled]="disabled()"
    (change)="toggle()"
  />

  <!-- Custom UI -->
  <div
    class="inline-block h-5 w-5 rounded border-2 transition-colors duration-200 text--on-primary"
    [style.background]="
      checked() ? 'linear-gradient(135deg, var(--primary) 0%, #dc2626 100%)' : null
    "
    [class.border-outline]="!checked()"
    [class.border-2]="!checked()"
    [class.bg-surface-container-highest]="!checked()"
    [class.opacity-50]="disabled()"
  >
    <!-- Checkmark -->
    @if (checked()) {
      <svg height="20" width="20" viewBox="0 0 22 18" fill="currentColor">
        <path
          d="M16.707 5.293a1 1 0 010 1.414l-7.25 7.25a1 1 0 01-1.414 0l-3.25-3.25a1 1 0 011.414-1.414L8.5 11.586l6.543-6.543a1 1 0 011.414 0z"
        />
      </svg>
    }
  </div>

  <!-- Label content -->
  <span class="text-sm text-on-surface">
    <ng-content />
  </span>
</label>
